import { create } from "zustand"

type StatusEstabelecimentoStore = {
    versao: number
    solicitarAtualizacao: () => void
}

const useStatusEstabelecimentoStore = create<StatusEstabelecimentoStore>()(set => ({
    versao: 0,
    solicitarAtualizacao: () => set(state => ({ versao: state.versao + 1 })),
}))

export default useStatusEstabelecimentoStore
